module.exports = __webpack_public_path__ + "img/book-tanakh.685c11d9.svg";